module.exports = __webpack_public_path__ + "img/map.a75c4c6e.svg";